import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { initTheme } from './utils/theme';
import { initProjectTheme } from './utils/projectTheme';
import { initAppInsights } from './utils/appInsights';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

initTheme();
initAppInsights();
initProjectTheme();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
